var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app"},[_c('menu-adm'),_c('v-main',{staticClass:"main-content"},[_c('header-normal'),_c('router-view')],1),_c('navegation-mobile')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }